// 平台
export const PlatformEnum = Object.freeze({
    IOS: {id: 32, name: 'iOS'},
    ANDROID: {id: 33, name: 'Android'},
    CTV: {id: 5201, name: 'CTV'}
});

// 状态
export const StatusEnum = Object.freeze({
    ONLINE: {id: 1, name: '开启(Online)'},
    OFFLINE: {id: 0, name: '关闭(Offline)'},
    BANNED: {id: -1, name: '封禁(Banned)'}
});

// 接入方式
export const AccessMethodEnum = Object.freeze({
    API: {id: 2, name: 'API'},
});

// 广告资源类型
export const ADSlotTypeEnum = Object.freeze({
    INTERSTITIAL: {id: 6, name: '插屏(Interstitial Ad)'},
    REWARD_VIDEO: {id: 5, name: '激励(Reward Video Ad)'},
    NATIVE: {id: 1, name: '信息流(Native Ad)'},
    BANNER: {id: 4, name: 'Banner(Banner Ad)'}
})

// 素材类型
export const MaterialTypeEnum = Object.freeze({
    IMAGE: {id: 1, name: '图片(Image)'},
    VIDEO: {id: 2, name: '视频(Video)'}
});

// 素材比例
export const ProportionTypeEnum = Object.freeze({
    VERTICAL: { id: 1, value: '9:16', name: '竖屏(Vertical)' },
    HORIZONTAL: { id: 2, value: '16:9', name: '横屏(Horizontal)' },
    SQUARE: { id: 3, value: '1:1', name: '方形(Square)' },
    BANNER: { id: 4, value: '32:5', name: '横幅(Banner)' },
    PORTRAIT: { id: 5, value: '6:5', name: '竖幅(Portrait)' }
})

// 价格策略
export const PricingStrategyEnum = Object.freeze({
    DYNAMIC: {id: 1, name: '动态底价(Dynamic Reserve Price)'},
    STATIC: {id: 2, name: '固定底价(Static Reserve Price)'},
})

// 时区
export const TIMEZONE = Object.freeze({
    UTC_8: 'UTC+8',
    UTC_0: 'UTC+0'
})
